import { ServiceData } from '@/types';

import audios from './MEDITATION_AUDIOS_NO.json';
import guides from './MEDITATION_GUIDES_NO.json';

export const MEDITATION_DATA_NO: ServiceData = {
  audios,
  guides,
};
